import { create } from "zustand";
import { devtools } from "zustand/middleware";

// Initialize domain detection immediately
const getInitialDomainState = () => {
  const hostname = window.location.hostname;
  const isKurv = hostname === 'agent.kurvpay.com';
  return { isKurvDomain: isKurv };
};

const useDomainStore = create(
  devtools((set) => ({
    ...getInitialDomainState(),
    
    initializeDomain: () => {
      const hostname = window.location.hostname;
      const isKurv = hostname === 'agent.kurvpay.com';
      set({ 
        isKurvDomain: isKurv
      });
    },
  }))
);

export default useDomainStore;
